// import { gatewayClient } from 'boot/axios'
import businessClient from 'src/services/clients/business'
import { IMeta, IAccountingJournal, IAccountingJournalView } from 'src/common/interfaces/index.js'

const IAccountingJournalResponse = { meta: IMeta, data: { list: [IAccountingJournal] } }
const IAccountingJournalViewResponse = { meta: IMeta, data: { list: [IAccountingJournalView] } }

export const accountingJournal = {
  /**
   * @param {{store_id: number, id: number}} filter
   * @return {IAccountingJournalResponse}
   */
  list(filter = {}, signal) {
    return businessClient().post('accounting/journals/portal/list', { filter }, { signal })
  },

  /**
   * @param {{store_id: number, id: number}} filter
   * @return {IAccountingJournalViewResponse}
   */
  journalView(filter = {}, signal) {
    return businessClient().post('accounting/journals/view', { filter }, { signal })
  },
  /**
   * @param {IAccountingJournal} data
   * @return {IAccountingJournalViewResponse}
   */
  insert(data = {}, signal) {
    return businessClient().post('accounting/journals/insert', { data }, { signal })
  },
}
